import Vue from 'vue';

const state = {
    images: [],
};

const getters = {
    getImages(state) {
        return state.images;
    }
};

const mutations = {
    SET_DATA(state, images) {
        state.images = images;
    },
};

const actions = {

    loadImages: function({dispatch, commit}, files ) {

        let data = new FormData();

        for (let i = 0; i < files.length; i++) {
            data.append('images[' + i + ']', files[i], files[i].name);
        }

        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/pircas/v1/images/", data, config )
                .then(({data}) => {

                    const images = [];

                    data.forEach((item) => {
                        images.push(item);
                    });

                    commit('SET_DATA', images);
                    resolve();

                }).catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
            });

        });
    },

    loadEntries: function ({dispatch, commit}, postID = 0) {

        const ID = postID || '';
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/lots/" + ID)
                .then(({data}) => {

                    let lotRows = [];

                    if (data instanceof Array) {

                        data.forEach((lot) => {

                            lotRows.push({
                                id: lot.id,
                                title: lot.title.rendered,
                                images: lot.acf.images.length,
                                video: lot.acf.video,
                            })

                        });

                    } else {

                        lotRows = {
                            id: data.id,
                            title: data.title.rendered,
                            images: data.acf.images,
                            video: data.acf.video,
                        }

                    }

                    commit('SET_DATA', lotRows);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

};

export const images = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};